













































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import TextOutput from '~/mixins/TextOutput';
import BrandCard from '~/components/BrandCard.vue';
import { Getter, State } from 'vuex-class';
import ItemList from './ItemList.vue';
import itemsForSaleByGala from '~/queries/paginatedStoreItems.gql';
import { IGameItemForSaleByGala } from '~/store/games/types';
import { IGame } from '~/store/games/types';
import { CopyToClipboard } from '~/mixins';
import { IInventoryCollection } from '../../../store/cms_content/types';
import { IOrderDetails } from '../../../types/order-details';
import {
  TransactionHashType,
  transactionTypeByHash,
} from '../../../utils/transactionTypeByHash';

@Component({
  components: {
    BrandCard,
    ItemList,
  },
})
export default class OrderConfirmation extends Mixins(
  TextOutput,
  CopyToClipboard,
) {
  @Prop(Object) readonly orderDetails!: IOrderDetails;
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, IInventoryCollection | undefined>;
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  relatedItems: IGameItemForSaleByGala[] = [];
  productTypes = {
    ethereum: ['item-pack', 'item'],
    gyri: ['galachain-item', 'galachain-allowance', 'item-pack-mix'],
    game: ['game-gem', 'spidertanks-profile-item'],
  };

  created() {
    console.log(this.orderDetails);
    if (this.orderDetails) {
      this.getRelatedItems(this.orderDetails);
    }
  }

  get truncatedTransactionHash() {
    const hash = this.orderDetails.paymentHash;
    if (hash) {
      const string = `${hash.slice(0, 6)}....${hash.substr(
        hash.length - 4,
        hash.length,
      )}`;
      return string;
    }
    return '';
  }

  get nextSteps() {
    return [
      {
        icon: require('@/assets/icons/icon_blockchain_pending.png'),
        text: this.$t(
          'components.games.items.orderConfirmation.fundsSent',
        ) as string,
      },
      {
        icon: require('@/assets/icons/icon_fundsreceive.png'),
        text: this.$t(
          'components.games.items.orderConfirmation.fundsReceived',
        ) as string,
      },
      {
        icon: require('@/assets/icons/icon_white_checkmark.png'),
        text: this.getOrderFinishedText(),
      },
    ];
  }

  get totals() {
    const { price, symbol } = this.orderDetails.selectedPrice;
    if (this.orderDetails.transactionFee && !this.isCreditCard) {
      const {
        fee: transactionFee,
        currency: transactionCurrency,
      } = this.orderDetails.transactionFee;
      if (transactionCurrency === symbol) {
        return [
          {
            total: parseFloat(price) + (transactionFee ?? 0),
            currency: symbol,
          },
        ];
      } else {
        return [
          { total: parseFloat(price), currency: symbol },
          { total: transactionFee, currency: transactionCurrency },
        ];
      }
    }
    return [{ total: price, currency: symbol }];
  }

  get isCreditCard() {
    return this.orderDetails.selectedPrice.symbol === 'USD';
  }

  get inventoryButtonText() {
    const productType = this.orderDetails.product.type;
    if (this.productTypes.ethereum.includes(productType)) {
      return 'View Inventory';
    } else if (this.productTypes.gyri.includes(productType)) {
      return 'View in Inventory';
    } else if (this.productTypes.game.includes(productType)) {
      return 'Play Game';
    }
  }

  get inventoryButtonLink() {
    const productType = this.orderDetails.product.type;
    if (this.productTypes.ethereum.includes(productType)) {
      return '/inventory';
    } else if (this.productTypes.gyri.includes(productType)) {
      return '/inventory';
    } else if (this.productTypes.game.includes(productType)) {
      return this.game ? `/games/${this.game?.route}` : null;
    }
  }

  get game() {
    return this.games.find(
      game => game.name === this.orderDetails.product.game,
    );
  }

  get paymentMethod() {
    if (this.orderDetails?.paymentHash) {
      const transactionHashType = transactionTypeByHash(
        this.orderDetails.paymentHash,
      );
      if (transactionHashType === TransactionHashType.STRIPE) {
        return this.$t(`components.wallet.paymentPicker.stripe`);
      } else if (transactionHashType === TransactionHashType.MOONPAY) {
        return this.$t(`components.wallet.paymentPicker.moonpay`);
      }
    }
    return this.filterGyriText(this.orderDetails.selectedPrice.symbol);
  }

  getOrderFinishedText() {
    const productName = this.orderDetails.product.name.toLowerCase();
    return productName.includes('node license')
      ? (this.$t(
          'components.games.items.orderConfirmation.readyForUse',
        ) as string)
      : productName.includes('gold membership')
      ? (this.$t(
          'components.games.items.orderConfirmation.goldMembershipActive',
        ) as string)
      : (this.$t(
          'components.games.items.orderConfirmation.itemsTransferred',
        ) as string);
  }

  @Watch('orderDetails')
  async getRelatedItems(orderDetails: IOrderDetails) {
    const paginatedStoreItemsInput = {
      currency: '',
      limit: 6,
      page: 1,
      platform: 'platform',
      stringFilterOptions: [
        {
          comparator: 'in',
          field: 'game',
          value: [orderDetails.product.game],
        },
      ],
      sortOptions: {
        sortDirection: -1,
        sortField: 'dateAvailable',
      },
    };
    const results = (await this.$apollo.query({
      query: itemsForSaleByGala,
      variables: {
        paginatedStoreItemsInput,
      },
      fetchPolicy: 'no-cache',
    })) as {
      data: {
        paginatedStoreItems: {
          products: any[];
          page: number;
          total: number;
          lastPage?: number;
        };
      };
    };

    if (results?.data?.paginatedStoreItems) {
      const { products } = results.data.paginatedStoreItems;
      this.relatedItems = products;
    }
  }

  filterSymbol(symbol: string) {
    return symbol?.replace(/\[ETH\]|\[GC\]|\[GalaChain\]|\[GYRI\]/, '');
  }

  getGameIcon(game: string) {
    return this.collectionIcons[game]?.inventoryImage;
  }

  get etherscanLink() {
    if (this.orderDetails.paymentHash) {
      return `https://${
        process.env.networkType === 'testnet' ? 'sepolia.' : ''
      }etherscan.io/tx/${this.orderDetails.paymentHash}`;
    }

    return '';
  }
}
